import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.me/971042766249" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2" aria-label="Contact us on WhatsApp" data-id="element-158" data-mp="1sev5dkuxm7y9">
      <MessageCircle className="h-8 w-8" data-id="element-159" data-mp="19g94o73buiuv" />
    </a>;
}